// extracted by mini-css-extract-plugin
module.exports = {"indentClass":"AttendanceComponent_indentClass_lAlm1"};